<template>
    <div>
        <div v-if="!hasChildren" class="">

            <!-- HEAD -->
            <div class="head row p-0 m-0 overflow-hidden">
                <div class="col-12 p-0 m-0 mb-5 pb-5 position-relative"  data-aos="fade-down" data-aos-easing="ease-out-cubic" data-aos-duration="500">
                    <div class="container position-absolute mt-0 mt-lg-5 pt-3 pt-lg-5 px-0 px-lg-3">
                        <div class="row justify-content-start justify-content-lg-end m-0 mt-0 mt-lg-5 pt-0 pt-lg-5">
                            <div class="col-7 col-lg-10 text-start text-lg-end">
                                <h1 v-html="$t('fundacion.we_are')"></h1>
                                <div class="col-12 col-lg-6 offset-0 offset-lg-6">
                                    <h4>{{ $t("fundacion.la_fundacion") }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="scrollDownLayer d-none d-lg-block">
                        <svg class="scrollDown svg-icon">
                            <use :href="`${publicPath}icons.svg#scrollDown`"/>
                        </svg>
                    </div>
                    <img :src="`${publicPath}img/02wearewater.jpg`" class="img-responsive d-none d-lg-block">
                    <img :src="`${publicPath}img/02wearewaterMobile.jpg`" class="img-responsive d-block d-lg-none" id="imgWearewater">
                </div>
            </div>
            <!-- end HEAD -->

            <div class="container-xxl ps-3 ps-lg-3">
                <div class="row justify-content-start justify-content-lg-between my-5 text-white">
                    <div class="col-12 col-lg-5 text-start pe-5 mt-3">
                        <img :src="`${publicPath}img/02wearewaterLogo.png`" class="img-responsive col-7">
                        <p class="txtGris">{{ $t("fundacion.la_pandemia") }}</p>
                        <h4 class="txtGris mt-5">{{ $t("fundacion.colaboracion") }}</h4>
                        <p class="txtGris">{{ $t("fundacion.en_los_proyectos") }}</p>
                        <img :src="`${publicPath}img/02wearewaterLogos.png`" class="img-responsive col-11">
                    </div>
                    <div class="col-12 col-lg-6 my-5">
                        <div class="row g-3">
                            <h4 class="mt-5 mt-lg-4 mt-0 text-start sizePlus">{{ $t("fundacion.proyectos_realizados") }}</h4>
                            <div class="col-6 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                                <div class="boxGris px-5 py-3 text-start">
                                    <div class="row justify-content-end my-5">
                                        <div class="col-5 p-0 m-0 pt-3 pt-lg-2">
                                            <img :src="`${publicPath}img/wearewaterIconsA.png`" class="img-responsive col-10">
                                        </div>
                                        <div class="col-6 p-0 m-0">
                                            <h2 class="mb-0"><AnimatedNumber
                                                    ref='numA'
                                                    :startAmount='0'
                                                    :endAmount='85'
                                                    :duration='3'
                                                    :separator=separator
                                                    :decimals='0'
                                                    :autoinit='true'
                                            /></h2>
                                            <h5 class="apetitir">{{ $t("fundacion.proyectos") }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                                <div class="boxGris px-5 py-3 text-start">
                                    <div class="row justify-content-end my-5">
                                        <div class="col-5 p-0 m-0 pt-3 pt-lg-2">
                                            <img :src="`${publicPath}img/wearewaterIconsB.png`" class="img-responsive col-10">
                                        </div>
                                        <div class="col-6 p-0 m-0">
                                            <h2 class="mb-0"><AnimatedNumber
                                                    ref='numB'
                                                    :startAmount='0'
                                                    :endAmount='33'
                                                    :duration='3'
                                                    :separator=separator
                                                    :decimals='0'
                                                    :autoinit='true'
                                            /></h2>
                                            <h5 class="apetitir">{{ $t("fundacion.paises") }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-12 aos-init aos-animate" data-aos="fade-up" data-aos-delay="750" data-aos-easing="easy-out" data-aos-duration="1000">
                                <div class="boxGris px-5 py-3 text-start">
                                    <div class="row justify-content-center my-5">
                                        <div class="col-2 p-0 m-0 pt-3 pt-lg-2">
                                            <img :src="`${publicPath}img/wearewaterIconsC.png`" class="img-responsive col-10">
                                        </div>
                                        <div class="col-8 col-lg-6 p-0 m-0">
                                            <h2 class="mb-0"><AnimatedNumber
                                                    ref='numC'
                                                    :startAmount='0'
                                                    :endAmount='3664501'
                                                    :duration='3'
                                                    :separator=separator
                                                    :decimals='0'
                                                    :autoinit='true'
                                            /></h2>
                                            <h5 class="apetitir">{{ $t("fundacion.personas_beneficiadas") }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid bg-black p-0 m-0">
                <div class="container-xxl pt-3 pt-lg-5 ps-3 ps-lg-0">
                    <div class="row my-5 text-white bg-black">
                        <div class="col-12 col-lg-6 text-start ps-3 ps-lg-3 pe-5">
                            <h2>{{ $t("nav.proyectos-de-cooperacion") }}</h2>
                        </div>
                        <div class="col-12 col-lg-6 p-3 p-lg-0 mb-0 mb-lg-5 text-start">
                            <h4 class="txtGris">{{ $t("fundacion.proyectos_de_cooperacion") }}</h4>
                        </div>
                    </div>
                    <div class="container-fluid d-none d-lg-block">
                        <div class="row justify-content-between text-white">
                            <div class="col-12 col-lg-5 text-end p-5 pe-0 pb-0">
                                <h4 class="mt-5 mb-3">{{ $t("fundacion.apoyo_a_refugiados") }}</h4>
                                <p class="txtGris">{{ $t("fundacion.proyectos_unicef") }}</p>
                            </div>
                            <div class="col-lg-6 p-0 m-0">
                                <img :src="`${publicPath}img/wearewaterImgA.jpg`" class="img-responsive">
                            </div>
                        </div>
                        <div class="row justify-content-between text-white">
                            <div class="col-6 p-0 m-0">
                                <img :src="`${publicPath}img/wearewaterImgB.jpg`" class="img-responsive">
                            </div>
                            <div class="col-5 text-start p-5 pe-0 pb-0">
                                <h4 class="mt-5 mb-3">{{ $t("fundacion.impulso_rural") }}</h4>
                                <p class="txtGris">{{ $t("fundacion.seguimiento") }}</p>
                            </div>
                        </div>
                        <div class="row justify-content-between text-white">
                            <div class="col-5 text-end p-5 pe-0 pb-0">
                                <h4 class="mt-5 mb-3">{{ $t("fundacion.agua_y_saneamiento") }}</h4>
                                <p class="txtGris">{{ $t("fundacion.proyectos_escuelas") }}</p>
                            </div>
                            <div class="col-6 p-0 m-0">
                                <img :src="`${publicPath}img/wearewaterImgG.jpg`" class="img-responsive">
                            </div>
                        </div>
                        <div class="row justify-content-between text-white">
                            <div class="col-6 p-0 m-0">
                                <img :src="`${publicPath}img/wearewaterImgC.jpg`" class="img-responsive">
                            </div>
                            <div class="col-5 text-start p-5 pe-0 pb-0">
                                <h4 class="mt-5 mb-3">{{ $t("fundacion.empoderamiento") }}</h4>
                                <p class="txtGris">{{ $t("fundacion.las_mujeres") }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid d-block d-lg-none">
                        <div class="row">
                            <div class="col-12">
                                <img :src="`${publicPath}img/wearewaterImgA.jpg`" class="img-responsive">
                            </div>
                            <div class="col-12 text-start pb-5">
                                <h3 class="my-3">{{ $t("fundacion.apoyo_a_refugiados") }}</h3>
                                <p class="txtGris">{{ $t("fundacion.proyectos_unicef") }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <img :src="`${publicPath}img/wearewaterImgB.jpg`" class="img-responsive">
                            </div>
                            <div class="col-12 text-start pb-5">
                                <h3 class="my-3">{{ $t("fundacion.impulso_rural") }}</h3>
                                <p class="txtGris">{{ $t("fundacion.seguimiento") }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <img :src="`${publicPath}img/wearewaterImgG.jpg`" class="img-responsive">
                            </div>
                            <div class="col-12 text-start pb-5">
                                <h3 class="my-3">{{ $t("fundacion.agua_y_saneamiento") }}</h3>
                                <p class="txtGris">{{ $t("fundacion.proyectos_escuelas") }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <img :src="`${publicPath}img/wearewaterImgC.jpg`" class="img-responsive">
                            </div>
                            <div class="col-12 text-start">
                                <h3 class="my-3">{{ $t("fundacion.empoderamiento") }}</h3>
                                <p class="txtGris">{{ $t("fundacion.las_mujeres") }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row my-0 my-lg-5 text-white">
                        <div class="col-12 text-start pe-5 ps-3 mt-0 mt-lg-5 pt-5">
                            <h2 id="blogNews">{{ $t("fundacion.acciones_concienciacion") }}</h2>
                        </div>
                    </div>
                    <div class="row g-3">
                        <div class="col-12 col-lg-4 text-start aos-init aos-animate" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                            <localized-link to="/fundacion-we-are-water/participacion-COP27" class="row justify-content-start p-0 m-0 my-2 my-lg-5">
                                <img :src="`${publicPath}img/wearewaterImgD.jpg`" class="img-responsive">
                                <h5 class="col-10 my-2 my-lg-3 mb-0 mb-lg-5">{{ $t("fundacion.participacion_cop27") }}</h5>
                            </localized-link>
                        </div>
                        <div class="col-12 col-lg-4 text-start aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                            <localized-link to="/fundacion-we-are-water/dia-mundial-agua" class="row justify-content-start p-0 m-0 my-2 my-lg-5">
                                <img :src="`${publicPath}img/wearewaterImgF.jpg`" class="img-responsive">
                                <h5 class="col-10 my-2 my-lg-3 mb-0 mb-lg-5">{{ $t("fundacion.dias_munisales") }}</h5>
                            </localized-link>
                        </div>
                        <div class="col-12 col-lg-4 text-start aos-init aos-animate" data-aos="fade-up" data-aos-delay="750" data-aos-easing="easy-out" data-aos-duration="1000">
                            <localized-link to="/fundacion-we-are-water/aquanautas" class="row justify-content-start p-0 m-0 my-2 my-lg-5">
                                <img :src="`${publicPath}img/wearewaterImgE.jpg`" class="img-responsive">
                                <h5 class="col-10 my-2 my-lg-3 mb-0 mb-lg-5">{{ $t("fundacion.aquanautas") }}</h5>
                            </localized-link>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer>
                <div class="row p-0 g-0">
                    <div class="col-6 border-top border-dark">
                        <localized-link to="/avanzando-hacia-el-futuro/personas" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                            <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                                <svg class="hoverEfect svg-icon iconFletxaLeft">
                                    <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                                </svg>
                            </div>
                            <div class="col-6 col-lg-auto text-start p-0 mt-5">
                                <h6 class="hoverEfect mt-4 mt-lg-0">{{ $t("site.anterior") }}</h6>
                                <h2 class="hoverEfect d-none d-lg-block">{{ $t("fundacion.personas") }}</h2>
                            </div>
                        </localized-link>
                    </div>
                    <div class="col-6 border-top border-start border-dark">
                        <localized-link to="/informe-financiero" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                            <div class="col-6 col-lg-auto text-end p-0 mt-5">
                                <h6 class="hoverEfect mt-4 mt-lg-0">{{ $t("site.siguiente") }}</h6>
                                <h2 class="hoverEfect d-none d-lg-block">{{ $t("fundacion.informe_financiero") }}</h2>
                            </div>
                            <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                                <svg class="hoverEfect svg-icon iconFletxaRight">
                                    <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                                </svg>
                            </div>

                        </localized-link>
                    </div>
                </div>
            </footer>
            <!-- Footer -->
        </div>
    </div>
        <router-view></router-view>
</template>

<script>
    import AnimatedNumber from "vue3-autocounter";
    export default {
        components: {
            AnimatedNumber
        },
        props: {
          hasChildren: Boolean
        },
        data() {
            return {
              publicPath: process.env.BASE_URL,
              separator: '.'
            }
        },
        mounted() {
            document.addEventListener('aos:in:counter', this.startCounter);
            if (this.$i18n.locale == "es") {
                this.separator = '.';
            } else {
                this.separator = ',';
            }
        },
        methods: {
            startCounter() {
                if (this.$refs.numA != null) {
                    this.$refs.numA.start();
                }
                if (this.$refs.numB != null) {
                    this.$refs.numB.start();
                }
                if (this.$refs.numC != null) {
                    this.$refs.numC.start();
                }
            }
        },

    }
</script>
